import { useState, useEffect } from 'react'

import { getDisplayHours, getOpenJumpPrice, LOCATIONS } from './open-jump-hours'

const buildSafeInfo = () => ({
  cgHours: getDisplayHours(LOCATIONS.COTTAGE_GROVE),
  dfHours: getDisplayHours(LOCATIONS.DEFOREST),
  price: getOpenJumpPrice(),
})

const infoFor = now => ({
  cgHours: getDisplayHours(LOCATIONS.COTTAGE_GROVE, now),
  dfHours: getDisplayHours(LOCATIONS.DEFOREST, now),
  price: getOpenJumpPrice(now),
})

/**
 * Open Jump hours and price for the visitor's current date.
 *
 * Gatsby bakes pages at build time, so date-sensitive values have to be
 * resolved in the browser or they freeze at whatever was true when the site
 * was last built. This seeds with the build-safe baseline (matching the static
 * HTML, so hydration stays clean) and re-resolves against the real date after
 * mount, the same pattern banner-messages.js uses.
 *
 * @returns {Object} { cgHours, dfHours, price }
 */
const useOpenJumpInfo = () => {
  const [info, setInfo] = useState(buildSafeInfo)

  useEffect(() => {
    setInfo(infoFor(new Date()))
  }, [])

  return info
}

export default useOpenJumpInfo
